import axios from "axios";
import { ENDPOINTS } from "../utils/api/endpoints";

// Public, token-authenticated endpoints (no login session) — mirrors the
// pattern used by the lien waiver signing link: the token from the URL is
// sent as a Bearer credential instead of a logged-in session token.
//
// TODO: these paths are placeholders — confirm the real endpoints with the
// backend and update here. Nothing else needs to change once they land,
// since every page only calls through this file.
const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? "";

const withToken = (token: string) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getPreconReviewByToken = (token: string) =>
  axios.get(`${BASE_URL}/public/precon-review/${token}`, withToken(token));

export const submitPreconDecision = (
  token: string,
  decision: "approve" | "reject",
  note?: string,
) =>
  axios.post(
    `${BASE_URL}/public/precon-review/${token}/decision`,
    { decision, note },
    withToken(token),
  );

export const getDrawReviewByToken = (token: string) =>
  axios.get(`${BASE_URL}/public/draw-review/${token}`, withToken(token));

export const submitDrawDecision = (
  token: string,
  decision: "approve" | "reject",
  note?: string,
) =>
  axios.post(
    `${BASE_URL}/public/draw-review/${token}/decision`,
    { decision, note },
    withToken(token),
  );

export const getPreconReportByToken = (token: string) =>
  axios.get(`${BASE_URL}/public/precon-report/${token}`, withToken(token));

export const getProgressReportByToken = (token: string) =>
  axios.get(`${BASE_URL}/public/progress-report/${token}`, withToken(token));

// Shared-link document download: the share URL's :resourceId/:token map to
// the same documents/download endpoint used for logged-in downloads, but
// authenticated with the share-link token instead of a session token.
export const getSharedDocumentBlob = (
  projectId: string,
  resourceId: string,
  token: string,
) =>
  axios.get(
    `${BASE_URL}${ENDPOINTS.DOCUMENTS.DOWNLOAD(projectId, resourceId, true)}`,
    {
      headers: { Authorization: `Bearer ${token}`, "x-role": "lender" },
      responseType: "blob",
    },
  );
